<template>
  <div class="test">
    <div class="vue-speedo-meter">
      <div>
        <VueSpeedometer :max-value="100" :value="numberCurrentValue" />
      </div>
      <div class="small-1">
        <VueSpeedometer
          :max-value="100"
          :value="numberCurrentValue"
          :fluidWidth="true"
          :ring-width="8"
          :needleHeightRatio="0.6"
          labelFontSize="0px"
          valueTextFontSize="0px"
        />
      </div>
    </div>
    <div class="high-chart">
      <div class="high-chart-big">
        <div id="container-big" class="container"></div>
      </div>
      <div class="high-chart-small">
        <div id="container-small"></div>
      </div>
    </div>
    <div class="apex-chart">
      <div class="apex-big">
        <VueApexCharts
          type="raidalBar"
          :options="getChartOptions(true)"
          :series="apexSeries"
          :height="300"
          :key="`b${key}`"
        />
      </div>
      <div class="apex-small">
        <VueApexCharts
          type="raidalBar"
          :options="getChartOptions()"
          :series="apexSeries"
          :height="100"
          :key="`s${key}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import the component
import VueSpeedometer from 'vue-speedometer';
import VueApexCharts from 'vue-apexcharts';
export default {
  name: 'SpeedoMeterTest',
  components: {
    VueApexCharts,
    VueSpeedometer,
  },
  data() {
    return {
      numberCurrentValue: 100,
      currentIntervalId: 0,
      optionsBig: {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -98,
            endAngle: 98,
            track: {
              background: '#e7e7e7',
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -2,
                fontSize: '22px',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        colors: ['#6AD72D'],
        fill: {},
        labels: ['Average Results'],
      },
      key: 0,
    };
  },
  computed: {
    apexSeries() {
      return [this.numberCurrentValue];
    },
    options() {
      return this.getChartOptions(true);
    },
  },
  methods: {
    getChartOptions() {
      return { ...this.optionsBig };
    },
    setUpHighChart(stringContainerId) {
      window.Highcharts.chart(stringContainerId, {
        chart: {
          type: 'gauge',
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: '80%',
        },

        title: {
          text: '',
        },

        pane: {
          startAngle: -90,
          endAngle: 89.9,
          background: null,
          center: ['50%', '75%'],
          size: '110%',
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,
          tickPixelInterval: 72,
          tickPosition: 'inside',
          tickColor: window.Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
          tickLength: 20,
          tickWidth: 2,
          minorTickInterval: null,
          labels: {
            distance: 20,
            style: {
              fontSize: '14px',
            },
          },
          lineWidth: 0,
          plotBands: [
            {
              from: 0,
              to: 40,
              color: '#55BF3B', // green
              thickness: 20,
            },
            {
              from: 40,
              to: 80,
              color: '#DDDF0D', // yellow
              thickness: 20,
            },
            {
              from: 80,
              to: 100,
              color: '#DF5353', // red
              thickness: 20,
            },
          ],
        },

        series: [
          {
            name: 'Speed',
            data: [this.numberCurrentValue],
            tooltip: {
              valueSuffix: '',
            },
            dataLabels: {
              format: '{y}',
              borderWidth: 0,
              color:
                (window.Highcharts.defaultOptions.title &&
                  window.Highcharts.defaultOptions.title.style &&
                  window.Highcharts.defaultOptions.title.style.color) ||
                '#333333',
              style: {
                fontSize: '16px',
              },
            },
            dial: {
              radius: '80%',
              backgroundColor: 'gray',
              baseWidth: 12,
              baseLength: '0%',
              rearLength: '0%',
            },
            pivot: {
              backgroundColor: 'gray',
              radius: 6,
            },
          },
        ],
      });
    },
    setUpInterval() {
      this.currentIntervalId = setInterval(() => {
        if (this.numberCurrentValue > 0) {
          this.numberCurrentValue -= 1;
          const chart = window.Highcharts.charts[0];
          if (chart) {
            const point = chart.series[0].points[0];
            point.update(this.numberCurrentValue);
          }
        } else {
          this.removeInterval();
        }
      }, 3000);
    },
    removeInterval() {
      if (this.currentIntervalId) {
        clearInterval(this.currentIntervalId);
      }
    },
  },
  mounted() {
    this.setUpHighChart('container-big');
    this.setUpHighChart('container-small');
    this.key += 1;
    this.setUpInterval();
  },
};
</script>

<style lang="scss" scoped>
.test {
  width: 100%;
}

.vue-speedo-meter {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.small-1 {
  width: 100px;
  height: 100px;
}

.high-chart {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.high-chart-big {
  width: 300px;
}

.high-chart-small {
  width: 100px;
}

.apex-chart {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
